export const ROUTING_NUMBER_LENGTH = 9
export const ACCOUNT_NUMBER_MAX_LENGTH = 50
export const ACCOUNT_HOLDER_NAME_MAX_LENGTH = 128
export const TOKEN_TYPE = "bank_account"
export enum WizardPearlType {
  Contractor = "Contractor",
  FTE = "FTE",
}
